import { render, staticRenderFns } from "./circle-progress.vue?vue&type=template&id=3b4b677d&scoped=true"
import script from "./circle-progress.vue?vue&type=script&lang=ts"
export * from "./circle-progress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b677d",
  null
  
)

export default component.exports